const API_ERROR_EVENT = 'api-error';

export function notifyApiError() {
  // Tắt hiển thị toast lỗi API/network trên giao diện
  return;
}

export function notifyApiException(error, fallbackUrl) {
  if (error?.__apiToastShown) {
    return false;
  }

  if (error && typeof error === 'object') {
    error.__apiToastShown = true;
  }

  notifyApiError(getApiExceptionPayload(error, fallbackUrl));
  return true;
}

export function getApiExceptionPayload(error, fallbackUrl) {
  return {
    message: error?.response?.data?.message || error?.response?.data?.error || error?.message,
    status: error?.response?.status,
    url: fallbackUrl || error?.config?.url,
  };
}

export function isApiException(error) {
  if (!error || typeof error !== 'object') {
    return false;
  }

  return Boolean(
    error.isAxiosError ||
    error.response ||
    error.config ||
    error.request ||
    error.name === 'AxiosError'
  );
}

export async function notifyFetchApiError(response) {
  let message = null;

  try {
    const contentType = response.headers.get('content-type') || '';
    const body = contentType.includes('application/json')
      ? await response.clone().json()
      : await response.clone().text();
    message = typeof body === 'string' ? body : body?.message || body?.error;
  } catch (e) {
    message = null;
  }

  notifyApiError({
    message,
    status: response.status,
    url: response.url,
  });
}

export function getApiErrorEventName() {
  return API_ERROR_EVENT;
}
